export const RADAR_SCOPE_TIER_VIEWER_PATH = '/radar/scope-tier'
export const RADAR_SCOPE_TIER_BATCH_PATH = '/radar/scope-tier/batch'

export function buildScopeTierPathWithQuery(
  basePath: string,
  query: Record<string, string | undefined>
): string {
  const params = new URLSearchParams()
  for (const [key, value] of Object.entries(query)) {
    if (value) {
      params.set(key, value)
    }
  }
  const suffix = params.toString()
  return suffix.length > 0 ? `${basePath}?${suffix}` : basePath
}
